import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from '#components/m/Modal'
import Button from '#components/a/Button'

export default class NachweisDetailHeaderModal extends Component {
  render() {
    const {id, confirmCallback, confirmText, trigger, children, disabled, secondary} = this.props
    const variant = secondary ? 'secondary' : 'primary'
    return (
      <Modal
        id={id}
        modifier="nachweisdetail__headerModal"
        trigger={<Button text={trigger} variant={variant} disabled={disabled} />}
        confirmCallback={confirmCallback}
        confirmText={confirmText}
        hasCloseButton
      >
        {children}
      </Modal>
    )
  }
}

NachweisDetailHeaderModal.propTypes = {
  id: PropTypes.string,
  confirmCallback: PropTypes.func,
  confirmText: PropTypes.string,
  trigger: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
}
